var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "625.000000pt",
    height: "625.000000pt",
    viewBox: "0 0 625.000000 625.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,625.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1400 5710 l0 -150 1735 0 1735 0 0 150 0 150 -1735 0 -1735 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830 4820 l0 -150 2295 0 2295 0 0 150 0 150 -2295 0 -2295 0 0 -150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 2275 l0 -1785 3025 0 3025 0 0 1785 0 1785 -3025 0 -3025 0 0 -1785z m5750 0 l0 -1485 -2725 0 -2725 0 0 1485 0 1485 2725 0 2725 0 0 -1485z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.c508366509a11d0d6012fa33f146c6fc.svg";
export { ForwardRef as ReactComponent };